import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "738d59e2-141f-465b-aadc-391f04c6dc65",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "A pressure value of <b>3 x 10<sup>-4</sup></b> Pa corresponds to:",
    suffixText: "dB SPL",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 24,
};
